import { alert } from 'actions/flash'
import { useCreateSherlockSsoTokenMutation } from 'api/sherlockSso'
import { buildTranslate } from 'locales'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

const SHERLOCK_BASE_URL =
  process.env.REACT_APP_SHERLOCK_URL || 'https://sherlock.thanx.com'

const t = buildTranslate('nav.customers_menu.sections.insights')

/**
 * Fetches a short-lived SSO token from the merchant API, then redirects the
 * opened window to sherlock.thanx.com so the user lands there authenticated.
 *
 * The new tab is opened synchronously (to avoid popup blockers) and its URL
 * is updated once the token fetch resolves.
 */
const useOpenSherlock = () => {
  const dispatch = useDispatch()
  const [createSherlockSsoToken, { isLoading }] =
    useCreateSherlockSsoTokenMutation()

  const openSherlock = useCallback(async () => {
    const newWindow = window.open('about:blank', '_blank')
    // Sever the back-reference so sherlock.thanx.com can't navigate the
    // dashboard tab via window.opener (reverse tabnabbing).
    if (newWindow) newWindow.opener = null

    const result = await createSherlockSsoToken()
    if ('error' in result) {
      newWindow?.close()
      dispatch(
        alert({
          key: 'danger',
          message: t('sherlock_ai_open_error'),
        })
      )
      return
    }

    const url = `${SHERLOCK_BASE_URL}/sso?token=${encodeURIComponent(
      result.data.token
    )}`
    if (newWindow) {
      newWindow.location.href = url
    } else {
      // Popup blocked — fall back to same-tab navigation
      window.location.href = url
    }
  }, [createSherlockSsoToken, dispatch])

  return { openSherlock, isLoading }
}

export default useOpenSherlock
